import Connection from './connection'
import Store from './store'

export default class Users extends Store {
  constructor(scope) {
    super(new Connection('users', scope))
    this.load()
  }
}



// WEBPACK FOOTER //
// client/stores/users.js